const invoiceStatusList = [{
  id: 1,
  name: 'pending',
  invoice_label: 'Generated',
}, {
  id: 2,
  name: 'checked',
  invoice_label: 'Checked',
}, {
  id: 3,
  name: 'invoice_accepted',
  invoice_label: 'Approved',
}, {
  id: 4,
  name: 'invoice_rejected',
  invoice_label: 'Returned',
}, {
  id: 5,
  name: 'physical_document_pending',
  invoice_label: 'Physical Document Pending',
}, {
  id: 6,
  name: 'physical_document_received',
  invoice_label: 'Physical Document Receviced',
  label_102: 'Pending',
}, {
  id: 7,
  name: 'librarian_accepted',
  invoice_label: 'Librarian Accepted',
  label_103: 'Pending',
}, {
  id: 8,
  name: 'librarian_rejected',
  invoice_label: 'Librarian Rejected',
}, {
  id: 9,
  name: 'payment_processing',
  invoice_label: 'Posted',
}, {
  id: 10,
  name: 'on_hold',
  invoice_label: 'On Hold',
}, {
  id: 11,
  name: 'payment_accepted',
  invoice_label: 'Paid',
}, {
  id: 12,
  name: 'payment_rejected',
  invoice_label: 'Pay Rejected',
}, {
  id: 13,
  name: 'payment_re_submitted',
  invoice_label: 'Re Submitted',
}, {
  id: 14,
  name: 'payment_ready_for_voucher',
  invoice_label: 'Invoice Updates',
}, {
  id: 15,
  name: 'voucher_created',
  invoice_label: 'Pending',
}];
export default invoiceStatusList;
